export default __webpack_public_path__ + "icon-facebook-95db18ff789581f4555c93d7237d10d9.svg";